import Authorization from './Authorization.js'
import Navigation from '../Navigation/Navigation'
import BerechtigungUtil from '../../services/BerechtigungUtil'

export default class AuthorizationFilter {

  constructor() {
    const activeRole = new BerechtigungUtil().getActiveProfile()?.role
    this.roles = {
      GENERIC: window.hasRole(Authorization.ROLES.GENERIC),
      BWL: activeRole === Authorization.ROLES.BWL,
      OSTRAL: activeRole === Authorization.ROLES.OSTRAL,
      VNB: activeRole === Authorization.ROLES.VNB,
      GP: activeRole === Authorization.ROLES.GP || activeRole === Authorization.ROLES.GP_SUPERUSER,
      GP_SUPERUSER: activeRole === Authorization.ROLES.GP_SUPERUSER
    }
  }

  viewAllowed(name) { // NOSONAR complexity: too many returns
    switch (name) {
      case Navigation.ROUTES.dashboard.url:
      case Navigation.ROUTES.onboarding.url:
      case '':
        return this._hasAnyRole()
      case Navigation.ROUTES.geschaeftspartner.url:
      case Navigation.ROUTES.gpStammdaten.url:
      case Navigation.ROUTES.gpVerbrauchsstaette.url:
      case Navigation.ROUTES.gpZVV.url:
        return this.roles.BWL || this.roles.OSTRAL || this.roles.VNB || this.roles.GP
      case Navigation.ROUTES.gpBenutzer.url:
        return this.roles.BWL || this.roles.OSTRAL || this.roles.VNB || this.roles.GP_SUPERUSER
      case Navigation.ROUTES.gpVerfuegungSetup.url:
        return this.roles.GP_SUPERUSER
      case Navigation.ROUTES.verteilnetzbetreiber.url:
      case Navigation.ROUTES.vnbStammdaten.url:
      case Navigation.ROUTES.vnbBenutzer.url:
        return this.roles.BWL || this.roles.OSTRAL || this.roles.VNB
      case Navigation.ROUTES.monitoringVerordnung.url:
        return this.roles.BWL || this.roles.OSTRAL || this.roles.GP
      case Navigation.ROUTES.monitoringKontingent.url:
      case Navigation.ROUTES.kontingentWeitergabe.url:
        return this.roles.GP
      case Navigation.ROUTES.monitoringVerbrauch.url:
      case Navigation.ROUTES.vnbImport.url:
      case Navigation.ROUTES.monitoringPeriodeVnb.url:
        return this.roles.BWL || this.roles.OSTRAL
      case Navigation.ROUTES.verordnung.url:
      case Navigation.ROUTES.verordnungCreate.url:
      case Navigation.ROUTES.verordnungEdit.url:
      case Navigation.ROUTES.verordnungDetail.url:
        return this.roles.BWL
      case Navigation.ROUTES.verfuegungNeu.url:
      case Navigation.ROUTES.verfuegungPendent.url:
      case Navigation.ROUTES.gpImport.url:
      case Navigation.ROUTES.vnbDashboardOffeneEinladungen.url:
        return this.roles.VNB
      case Navigation.ROUTES.zvvStammdaten.url:
      case Navigation.ROUTES.zvvMitglieder.url:
        return this._hasZVV()
      default:
        return false
    }
  }

  _hasAnyRole() {
    return Object.values(this.roles).find(value => value === true) || false
  }

  hasOnlyGeneric() {
    return this.roles.GENERIC && Object.values(this.roles).filter(v => v === true).length === 1
  }

  _hasZVV() {
    return new BerechtigungUtil().getActiveProfile()?.zvvExtId
  }
}
